// Updated DesignForm.jsx with reusable MainField component
import React, { useState } from 'react';
import styles from './DesignForm.module.css';
import MainField from '../../components/MainField/MainField';
import { FiEdit2 } from 'react-icons/fi';
import { MdDragHandle } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';

const FIELD_TYPES = [
  { type: 'text', label: 'Text' },
  { type: 'number', label: 'Number' },
  { type: 'checkbox', label: 'Check Box' },
  { type: 'dropdown', label: 'Dropdown' },
  { type: 'image', label: 'Image' },
  { type: 'date', label: 'Date' },
  { type: 'time', label: 'Time' },
];

const SECTION_COLORS = {
  'Child Information': '#A2D9A2',
  'Parent one': '#C6C4F5',
  'Parent two': '#C6C4F5',
};

export default function DesignForm() {
  const [fields, setFields] = useState([]);
  const [activeSection, setActiveSection] = useState('Child Information');
  const [collapsedSections, setCollapsedSections] = useState([]);
  const [sectionPageBreaks, setSectionPageBreaks] = useState({});

  const handlePageBreakCheck = (section) => {
    setSectionPageBreaks((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleAddField = (type) => {
    const newField = {
      id: Date.now(),
      section: activeSection,
      type,
      label: type.charAt(0).toUpperCase() + type.slice(1),
      mandatory: false,
      pageBreak: false,
    };
    setFields((prev) => [...prev, newField]);
  };

  const toggleProperty = (id, prop) => {
    setFields((prev) =>
      prev.map((f) => (f.id === id ? { ...f, [prop]: !f[prop] } : f))
    );
  };

  const deleteField = (id) => {
    setFields((prev) => prev.filter((f) => f.id !== id));
  };

  const toggleCollapse = (section) => {
    setCollapsedSections((prev) =>
      prev.includes(section)
        ? prev.filter((s) => s !== section)
        : [...prev, section]
    );
  };

  return (
    <div className={styles.designFormWrapper}>
      <div className={styles.leftPanel}>
        <div className={styles.sectionList}>
          {Object.keys(SECTION_COLORS).map((section) => (
            <button
              key={section}
              className={`${styles.sectionBtn} ${
                activeSection === section ? styles.activeSection : ''
              }`}
              onClick={() => setActiveSection(section)}
            >
              {section} <span className={styles.plus}>+</span>
            </button>
          ))}
        </div>

        <div className={styles.fieldPalette}>
          <h4>Form Fields</h4>
          {FIELD_TYPES.map((field) => (
            <button
              key={field.type}
              className={styles.fieldBtn}
              onClick={() => handleAddField(field.type)}
            >
              {field.label}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.rightPanel}>
        {Object.keys(SECTION_COLORS).map((section) => (
          <div key={section} className={styles.sectionGroup}>
            <MainField
              title={section}
              checked={sectionPageBreaks[section] || false}
              onCheck={() => handlePageBreakCheck(section)}
              onEdit={() => {}}
              onDelete={() => {}}
              onToggleCollapse={() => toggleCollapse(section)}
              collapsed={collapsedSections.includes(section)}
            />

            {/* {!collapsedSections.includes(section) &&
              fields
                .filter((f) => f.section === section)
                .map((field) => (
                  <div key={field.id} className={styles.card}>
                    <div className={styles.cardHeader}>
                      <span className={styles.label}>
                        {field.label}
                        <span className={styles.type}>Type: {field.type}</span>
                      </span>
                      <div className={styles.actions}>
                        <FiEdit2 />
                        <RiDeleteBin6Line
                          onClick={() => deleteField(field.id)}
                        />
                        <MdDragHandle />
                      </div>
                    </div>
                    <div className={styles.options}>
                      <label>
                        <input
                          type="checkbox"
                          checked={field.mandatory}
                          onChange={() => toggleProperty(field.id, "mandatory")}
                        />{" "}
                        Mandatory
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={field.pageBreak}
                          onChange={() => toggleProperty(field.id, "pageBreak")}
                        />{" "}
                        Insert page break after the field
                      </label>
                      {field.type === "dropdown" && (
                        <button className={styles.addValueBtn}>
                          Add Value
                        </button>
                      )}
                    </div>
                  </div>
                ))} */}
          </div>
        ))}
      </div>
    </div>
  );
}
